// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__B_avb","right":"styles_right__1De7b"};